export default "__VITE_ASSET__5gts1y1Q__"